export const AppStarRatingIcon = () => {
  return (
    <svg
      data-testid="app-star-rating-svg"
      width="88"
      height="16"
      viewBox="0 0 88 12"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          id="0trfkqh50a"
          d="m8 12-4.702 2.472.898-5.236L.392 5.528l5.257-.764L8 0l2.351 4.764 5.257.764-3.804 3.708.898 5.236z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFF"
          d="m8 12-4.702 2.472.898-5.236L.392 5.528l5.257-.764L8 0l2.351 4.764 5.257.764-3.804 3.708.898 5.236zM26 12l-4.702 2.472.898-5.236-3.804-3.708 5.257-.764L26 0l2.351 4.764 5.257.764-3.804 3.708.898 5.236zM44 12l-4.702 2.472.898-5.236-3.804-3.708 5.257-.764L44 0l2.351 4.764 5.257.764-3.804 3.708.898 5.236zM62 12l-4.702 2.472.898-5.236-3.804-3.708 5.257-.764L62 0l2.351 4.764 5.257.764-3.804 3.708.898 5.236z"
        />
        <g transform="translate(72)">
          <mask id="6mr67sgpdb" fill="#fff">
            <use href="#0trfkqh50a" />
          </mask>
          <use fillOpacity=".5" fill="#FFF" href="#0trfkqh50a" />
          <path fill="#FFF" mask="url(#6mr67sgpdb)" d="M1-3h7v19H1z" />
        </g>
      </g>
    </svg>
  );
};

export default AppStarRatingIcon;
